<template>

  <button class="btn btn-primary"
          v-if="  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
    @click="router.push({
      name: 'unemployedPrivateCoachingList',
      params: { id: unemployedId}
    })">
    <i class="os-icon os-icon-edit"></i>
  </button>

  <button class="btn btn-primary"
          v-if="currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES'"
          @click="router.push({
      name: 'unemployedSocioTherapyCoachingList',
      params: { id: unemployedId}
    })">
    <i class="os-icon os-icon-edit"></i>
  </button>

</template>

<script setup>
import router from '@/router';
import { piniaUserStore } from '@/store/piniaUserStore';
import { computed, defineProps } from 'vue';

const piniaUserState   = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole  = piniaCurrentUser.value.roles[ 0 ];

const props = defineProps({
  unemployedId: {
    type: Number,
    required: true,
  },
});

</script>
